import '../sass/icon-cards.scss';

(() => {
    const swiperScript = document.querySelector('#ofg-schools-swiper-js');
    const $blocks = document.querySelectorAll('.block.icon-cards');

    if (!$blocks.length) return;

    $blocks.forEach($block => {
        const $carousel = $block.querySelector('.icon-cards__carousel');
        const $pagination = $block.querySelector('.icon-cards__pagination');

        const initCarousel = () => {
            if (!$carousel || typeof Swiper === 'undefined') return;

            new Swiper($carousel, {
                slidesPerView: 1,
                spaceBetween: 0,
                pagination: {
                    el: $pagination,
                    type: 'bullets',
                    clickable: true,
                },
            });
        };

        if (typeof Swiper !== 'undefined') {
            initCarousel();
        } else if (swiperScript) {
            swiperScript.addEventListener('load', () => {
                initCarousel();
            });
        } else {
            window.addEventListener('load', () => {
                initCarousel();
            });
        }
    });
})();
